// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"article-module--mainContainer--8NsSm","altMainContainer":"article-module--altMainContainer--2FI2G"};